<div class="flex flex-col gap-6 p-6">
  <div class="flex flex-col items-center text-center">
    <div class="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mb-4">
      <i class="fi-rr-exclamation text-3xl text-orange-500"></i>
    </div>
    <h2 class="font-semibold text-xl text-gray-800 mb-2">
      Cambiar bodega activa
    </h2>
    <p class="text-gray-600 text-sm">
      Estás a punto de cambiar la bodega con la que trabajarás.
    </p>
  </div>

  <div class="flex flex-col gap-3">
    <div class="bg-gray-50 rounded-xl p-4 border border-gray-200">
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 rounded-xl bg-gray-400 flex items-center justify-center">
          <i class="fi-rr-box text-lg text-white"></i>
        </div>
        <div class="flex flex-col flex-1">
          <span class="text-xs text-gray-500 uppercase font-medium">Actual</span>
          <span class="font-semibold text-base text-gray-800">{{ data.currentWarehouseName }}</span>
          <span class="text-sm text-gray-600">{{ data.currentWarehouseCode }}</span>
        </div>
      </div>
    </div>

    <div class="flex justify-center">
      <i class="fi-rr-arrow-down text-2xl text-orange-500"></i>
    </div>

    <div class="bg-orange-50 rounded-xl p-4 border-2 border-orange-500">
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 rounded-xl bg-orange-500 flex items-center justify-center">
          <i class="fi-rr-box text-lg text-white"></i>
        </div>
        <div class="flex flex-col flex-1">
          <span class="text-xs text-orange-600 uppercase font-medium">Nueva</span>
          <span class="font-semibold text-base text-orange-900">{{ data.newWarehouseName }}</span>
          <span class="text-sm text-orange-700">{{ data.newWarehouseCode }}</span>
        </div>
      </div>
    </div>
  </div>

  <p class="text-gray-500 text-sm text-center">
    Todas las transacciones que realices a partir de ahora se asociarán a la nueva bodega.
  </p>
</div>

<div class="flex flex-row gap-3 justify-end px-6 pb-6">
  <button
    class="rounded-3xl flex items-center gap-2 bg-gray-200 text-gray-700 py-3 px-6 cursor-pointer hover:bg-gray-300 transition-all"
    (click)="close(false)">
    <span class="text-base font-medium">Cancelar</span>
  </button>
  <button
    class="rounded-3xl flex items-center gap-2 bg-orange-500 text-white py-3 px-6 cursor-pointer hover:bg-orange-600 transition-all"
    (click)="close(true)">
    <span class="text-base font-medium">Confirmar cambio</span>
    <i class="fi-rr-check text-base flex"></i>
  </button>
</div>
